module.exports = __webpack_public_path__ + "static/img/3-1-4.64370bf8.jpg";